import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  minBreakpointQuery,
  sectionMargins,
  sectionPaddings,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';
import ImageContentCard from './ImageContentCard';

const StyledImageContentCards = styled.section`
  --gap: 30px;
  --items: 1;
  ${sectionMargins()};
`;

const StyledContainer = styled(Container)`
  ${({ highlight }) => {
    if (!highlight) {
      return css`
        padding-right: 0;
        padding-left: 0;
      `;
    }
  }}
`;

const StyledInner = styled.div`
  ${({ highlight }) => {
    if (highlight) {
      return css`
        ${sectionPaddings('40px', '90px')};
        background-color: ${brandColours.primary};
        border-radius: 50px;
      `;
    }
  }}
`;

const StyledHeader = styled.header`
  max-width: 880px;
  text-align: center;
  margin: 0 auto;
`;

const StyledText = styled(HtmlContent)`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 40px;
  `}
`;

const StyledHeading = styled(Heading)`
  max-width: 640px;
  margin: 0 auto;
`;

const StyledItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: var(--gap);
  margin-top: 30px;

  ${minBreakpointQuery.small`
    margin-top: 40px;
  `}

  ${minBreakpointQuery.medium`
    --gap: 40px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 50px;
  `}

  ${minBreakpointQuery.xxlarge`
    margin-top: 60px;
  `}

  ${({ isFour }) => {
    if (!isFour) {
      return css`
        ${minBreakpointQuery.xlarge`
          --gap: 50px;
        `}
      `;
    }
  }}
`;

const StyledItem = styled(ImageContentCard)`
  width: calc(
    (100% / var(--items)) - (var(--gap) * (var(--items) - 1) / var(--items))
  );

  ${({ isFour }) => {
    if (isFour) {
      return css`
        ${minBreakpointQuery.tsmall`
          --items: 2;
        `}

        ${minBreakpointQuery.mlarge`
          --items: 4;
        `}
      `;
    } else {
      return css`
        ${minBreakpointQuery.smedium`
          --items: 3;
        `}
      `;
    }
  }}
`;

const ImageContentCards = ({ heading, text, items, highlight }) => (
  <StyledImageContentCards>
    <StyledContainer wider={true} highlight={highlight}>
      <StyledInner highlight={highlight}>
        <Container>
          <StyledHeader>
            <StyledHeading>{heading}</StyledHeading>
            <StyledText content={text} />
          </StyledHeader>
          <StyledItems isFour={items.length === 4}>
            {items.map(({ image, heading, text, link }, id) => (
              <StyledItem
                key={id}
                image={image}
                heading={heading}
                text={text}
                link={link}
                isFour={items.length === 4}
              />
            ))}
          </StyledItems>
        </Container>
      </StyledInner>
    </StyledContainer>
  </StyledImageContentCards>
);

export default ImageContentCards;
